"use strict"; // cSpell:disable
// tslint:disable:max-line-length no-reserved-keywords

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROTEIN_COMMENT_TYPE;

(function (PROTEIN_COMMENT_TYPE) {
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["DISEASE"] = 0] = "DISEASE";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["DOMAIN"] = 1] = "DOMAIN";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["FUNCTION"] = 2] = "FUNCTION";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["INTERACTION"] = 3] = "INTERACTION";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["MIM"] = 4] = "MIM";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["PTM"] = 5] = "PTM";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["SIMILARITY"] = 6] = "SIMILARITY";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["SUBCELLULAR_LOCATION"] = 7] = "SUBCELLULAR_LOCATION";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["SUBUNIT"] = 8] = "SUBUNIT";
  PROTEIN_COMMENT_TYPE[PROTEIN_COMMENT_TYPE["WEBRESOURCE"] = 9] = "WEBRESOURCE";
})(PROTEIN_COMMENT_TYPE = exports.PROTEIN_COMMENT_TYPE || (exports.PROTEIN_COMMENT_TYPE = {}));